import { ACCOUNT_PARAM } from '#pplx/frontend/account-navigation/constants.js';
import { clearActiveQuery } from '#pplx/frontend/apps/ask/stores/queryInput.js';
import { toPublicWebUrl } from '#pplx/frontend/common/location.js';
import { sanitizedRedirectWindow } from '#pplx/frontend/common/sanitizedRedirectWindow.js';
export function getSafeAccountRedirectPath(redirectPath) {
    try {
        const publicWebUrl = new URL(toPublicWebUrl('/'));
        const redirectUrl = new URL(redirectPath, publicWebUrl);
        if (redirectUrl.origin !== publicWebUrl.origin || redirectUrl.pathname.startsWith('//')) {
            return '/';
        }
        return `${redirectUrl.pathname}${redirectUrl.search}${redirectUrl.hash}`;
    }
    catch {
        return '/';
    }
}
/**
 * Switch this tab to another linked account (multi-account web, plan PR 3.2). Hard-redirects the
 * **current tab** to the requested path, bound to the target account via the ephemeral
 * `?pplx_account=` bootstrap param, which `applyAccountFromUrl` consumes (and strips) on load — so
 * switching feels like switching and lands on a clean destination for the new account. Other open
 * tabs keep their own active account (per-tab `sessionStorage`), so multi-tab independence (RFC
 * §7.1) is preserved.
 */
export function switchAccount(accountId, redirectPath = '/') {
    // Drop the home ask-input draft before redirecting: it lives in non-namespaced `sessionStorage`,
    // which survives the same-tab reload, so without this the previous account's typed query would
    // carry over to the new account (file uploads already clear, since they're only in memory).
    clearActiveQuery();
    const url = new URL(toPublicWebUrl(getSafeAccountRedirectPath(redirectPath)));
    url.searchParams.set(ACCOUNT_PARAM, accountId);
    sanitizedRedirectWindow(url.toString());
}
//# sourceMappingURL=switchAccount.js.map